export default [
  {
    path: "/team",
    name: "Team",
    component: () => import("@/views/Page/Team/Team.vue"), // the component path
    meta: {
      title: "Team",
    },
  },

  {
    path: "/assign-users/:id",
    name: "AssignUsers",
    component: () => import("@/views/Page/Team/AssignUsers.vue"),
    props: true, // Pass the route parameter as a prop
    meta: {
      title: "Assign Users",
    },
  },
];
